export default {
  title: 'Reset password',
  username: 'Enter username',
  mobile: 'Phone number',
  code: 'Verification code',
  password: 'Create new password',
  confirm: 'Confirm new password',
  form: 'Set new password',
  js: {
    error: 'Failure',
    success: 'Success',
    sendAgain: 'Resend',
    send: 'Send code'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/password.js